import { defineComponent as _defineComponent } from 'vue'
import { type MetricType } from '~/types/types'

export default /*#__PURE__*/_defineComponent({
  __name: 'DirectComputationalChildren',
  props: {
  metric: { type: Object as () => MetricType, required: true },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})